export const TYPE_COLORS = {
  BUG:         '#9fca59',
  DARK:        '#303041',
  DRAGON:      '#f87d11',
  ELECTRIC:    '#f5c20e',
  FIGHTING:    '#79442d',
  FIRE:        '#fa645f',
  FLYING:      '#6d7a9f',
  GHOST:       '#6e3b72',
  GRASS:       '#40a00c',
  GROUND:      '#94745d',
  ICE:         '#46c2cf',
  NORMAL:      '#ecb8b8',
  POISON:      '#8cb126',
  PSYCHIC:     '#d94dc5',
  ROCK:        '#474747',
  STEEL:       '#8f8e8e',
  WATER:       '#325dae',
  ULTIMATE:    '#5a227a',
}

export const TYPE_GREY_COLORS = {
  BUG:         '#C3CEB1',
  DARK:        '#636368',
  DRAGON:      '#C8B196',
  ELECTRIC:    '#E1D3A0',
  FIGHTING:    '#847771',
  FIRE:        '#C8A8A2',
  FLYING:      '#969AA5',
  GHOST:       '#7F6F81',
  GRASS:       '#8AA47D',
  GROUND:      '#A19993',
  ICE:         '#AFCFD4',
  NORMAL:      '#DCCFCF',
  POISON:      '#CAD1B7',
  PSYCHIC:     '#B17BAB',
  ROCK:        '#A2A2A2',
  STEEL:       '#AAAAAB',
  WATER:       '#627496',
  ULTIMATE:    '#CAD1B7',
}

export const TYPE_DARK_THEME = {
  BUG:         false,
  DARK:        true,
  DRAGON:      false,
  ELECTRIC:    false,
  FIGHTING:    true,
  FIRE:        false,
  FLYING:      false,
  GHOST:       true,
  GRASS:       false,
  GROUND:      false,
  ICE:         true,
  NORMAL:      false,
  POISON:      false,
  PSYCHIC:     true,
  ROCK:        true,
  STEEL:       false,
  WATER:       true,
  ULTIMATE:    true,
}

// Sdileny styl pro primy v-chip reprezentujici typ (ne TypePill komponentu -
// chip-group registruje vyber jen na primych v-chip potomcich, viz
// SkillPickerDialog.vue a Pokedex.vue).
export function typeChipStyle(typeId) {
  return {
    backgroundColor: TYPE_COLORS[typeId],
    color: TYPE_DARK_THEME[typeId] ? '#fff' : '#000',
  };
}
